import {  OrderType, Payments } from "@/constants";
import { Setup } from "@/types";
import { Button, Popup, PopupProps, SafeArea, Selector } from "antd-mobile";
import { ActionType, PageState } from "./listLogic";
import styles from "./Filter.module.scss";
import { ReactNode } from "react";
type TradeOption = {
  label: ReactNode;
  value: Payments;
}
export interface ListFilterProps extends PopupProps {
  logic: Setup.Logic<PageState, ActionType> & {
    resetFilters: () => void;
    applyFilters: () => void;
  };
  tradePaymentOptions:TradeOption[]
}


const tradeSplitOptions = [
  {
    label: "可拆分",
    value: OrderType.SEPARABLY,
  },
  {
    label: "不可拆分",
    value: OrderType.INSEPARABLY,
  },
];

const tradeStatusOptions = [
  {
    label: "已发起交易",
    value: 'isTransacting',
  },
  {
    label: "挂单中",
    value: 'isHanging',
  },
];

const isProfessionOptions = [
  {
    label: "超级挂单",
    value: 2,
  },
  {
    label: "普通挂单",
    value: 1,
  },
];

export const ListFilter = ({ visible, logic, tradePaymentOptions, ...rest }: ListFilterProps) => {
  return (
    <Popup
      visible={visible}
      showCloseButton={true}
      {...rest}
      bodyClassName={styles.body}
    >
      <div className={styles.title}>筛选</div>
      <div className={styles.content}>
        <div className={styles.fieldTitle}>交易方式</div>
        <Selector
          className={styles.selector}
          value={logic.state.paymentType}
          showCheckMark={false}
          multiple={true}
          options={tradePaymentOptions}
          onChange={(v) => {
            logic.dispatch({ type: "update-paymentType", paymentType: v });
          }}
        />
        <div className={styles.fieldTitle}>交易状态</div>
        <Selector
          className={styles.selector}
          value={logic.state.tradeStatus}
          showCheckMark={false}
          multiple={true}
          options={tradeStatusOptions}
          onChange={(v) => {
            logic.dispatch({ type: "update-tradeStatus", tradeStatus: v });
          }}
        />
        <div className={styles.fieldTitle}>是否可拆分</div>
        <Selector
          className={styles.selector}
          value={logic.state.isSplit}
          showCheckMark={false}
          options={tradeSplitOptions}
          onChange={(v) => {
            logic.dispatch({ type: "update-isSplit", isSplit: v });
          }}
        />
        <div className={styles.fieldTitle}>订单类型</div>
        <Selector
          className={styles.selector}
          value={logic.state.professionStatus}
          showCheckMark={false}
          options={isProfessionOptions}
          onChange={(v) => {
            logic.dispatch({ type: "update-professionStatus", professionStatus: v });
          }}
        />
        <div className={styles.buttonGroup}>
          <Button
            className={styles.resetButton}
            onClick={() => {
              logic.resetFilters();
            }}
          >
            重置
          </Button>
          <Button
            className={styles.applyButton}
            onClick={() => {
              logic.applyFilters();
            }}
          >
            应用
          </Button>
        </div>
        <div className={styles.bottomPrompt}>仅显示可用的交易方式</div>
      </div>
      <SafeArea position="bottom" />
    </Popup>
  );
};
